import React from 'react';

export default () => (<b style={{color:"red"}}>*</b>);